import React, { useEffect, useState } from 'react';
import {
    Box,
    TextField,
    Button,
    CircularProgress,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Pagination,
    Divider,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import axios from 'axios';
import apiUrl from '../../Config';
import { useNavigate } from 'react-router-dom';

const DisplayUsers = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [page, setPage] = useState(1);
    const [limit,setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate()

    const fetchUsers = async () => {
        setLoading(true);
        setError('');

        try {
            const response = await axios.get(apiUrl + '/user/getallusers', {
                params: {
                    page,
                    limit,
                    searchTerm: searchQuery
                }
            });

            const data = response?.data;

            if (data?.status === true) {
                setUsers(data?.users);
                setTotalPages(data?.totalPages);
            } else {
                setError(data?.message || 'Failed to fetch users');
            }
        } catch (err) {
            setError(err.message || 'Error fetching users');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, searchQuery,limit]);
    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };

    const handleSearchSubmit = () => {
        setPage(1);
        setSearchQuery(searchTerm);
    };
    const handleViewClick = (userId) => {
        navigate('/user-details', { state: { userId } })
    }

    return (
        <Box p={3} mt={2}>
            <Typography variant="h4" gutterBottom>
                Bookings
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {/* Grid for Search */}
            <Grid container spacing={2} mb={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Grid item siz={{ xs: 12, sm: 4 }}>
                    <TextField
                        label="Search by name or email"
                        variant="outlined"
                        fullWidth
                        size='small'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Grid>
                <Grid item size={{ xs: 12, sm: 2 }} >
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        size='small'
                        onClick={handleSearchSubmit}
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>

            {loading ? (
                <Box textAlign="center" my={4}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Typography color="error">{error}</Typography>
            ) : (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Created At</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.length > 0 ? users.map((user) => (
                                    <TableRow key={user.id}>
                                        <TableCell>{user.name}</TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>{user.phoneNumber}</TableCell>
                                        <TableCell>{new Date(user.createdAt).toLocaleString()}</TableCell>
                                        <TableCell>
                                            <Button variant='outlined' onClick={() => handleViewClick(user.id)}>View</Button>
                                        </TableCell>
                                    </TableRow>
                                )) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            No users found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'end', alignItems: 'center', flexWrap: 'wrap', gap: 2 ,mt:3}}>
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                            <Select
                                labelId="rows-per-page-label"
                                value={limit}
                                onChange={handleLimitChange}
                                label="Rows per page"
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {totalPages > 1 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                color="primary"
                                showFirstButton
                                showLastButton
                                siblingCount={0}
                                boundaryCount={1}
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        height: 30,
                                        minWidth: 30,
                                        fontSize: '1rem',
                                        marginTop: '10px'
                                    }
                                }}
                            />
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default DisplayUsers;
